import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar'; // Importa Toolbar

import {useRightDrawer} from "../../../contexts/application/RightDrawerContext";
import Chat from "../Chat/Chat";
import {RIGHT_DRAWER_WIDTH} from "../../../constants/styles";
import {MINI_DRAWER_WIDTH, DRAWER_WIDTH} from "@/config";
import {useFullscreenChat, widthChat} from "@/contexts/FullscreenContext";



export default function RightDrawer() {
    const {isOpen} = useRightDrawer()
    const {isFullscreenChat, widthChat, setIsFullscreenChat} = useFullscreenChat()

    const currentWidth = widthChat(isOpen, isFullscreenChat)

    return (
        <Drawer
            data-tour={"total_chat_ai_ask"}
            variant="permanent"
            anchor="right"
            sx={{
                // Quando è aperto occupa spazio e spinge il layout principale!
                width: currentWidth,
                flexShrink: 0,
                whiteSpace: 'nowrap',
                boxSizing: 'border-box',
                transition: (theme) => theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                '& .MuiDrawer-paper': {
                    width: currentWidth,
                    boxSizing: 'border-box',
                    borderLeft: '1px solid',
                    borderLeftColor: 'divider',
                    boxShadow: 'inherit',
                    // Importante: zIndex minore di quello dell'header (che è theme.zIndex.drawer + 1)
                    zIndex: (theme) => theme.zIndex.drawer,
                    transform: isOpen ? 'none' : `translateX(${RIGHT_DRAWER_WIDTH})`,
                    transition: (theme) => theme.transitions.create('transform', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.enteringScreen,
                    }),
                },
            }}
        >
            <Toolbar/>
            <Box sx={{ height: 'calc(100% - 64px)', p: 0 }}>
                <Chat/>
            </Box>
        </Drawer>
    );
}